export default "__VITE_ASSET__DiTSS9Dy__"